module.exports = __webpack_public_path__ + "img/face-head-bandage.ca705ba3.svg";